module.exports = __webpack_public_path__ + "static/media/HelveticaNeueCyr-Regular.49404209.woff";